// extracted by mini-css-extract-plugin
export default {"mCard":"wE-z","image":"xE-z","imageNoBackground":"yE-z","imageHasCategory":"zE-z","fullWidth":"AE-z"};